import classNames from 'classnames';
import { FlexContainer, Spinner } from 'components';
import BrandLogo from '../BrandLogo';
import styles from './LoadingPlaceholder.module.scss';

/**
 * LoadingPlaceholder
 *
 * @return {JSX.Element}
 */
const LoadingPlaceholder = ({ className, spinner, padding, white }) => {
  return (
    <FlexContainer
      className={classNames(
        styles.LoadingPlaceholder,
        spinner && styles.LoadingPlaceholder__spinner,
        padding && styles.LoadingPlaceholder__padding,
        white && styles.LoadingPlaceholder__white,
        className,
        `${LoadingPlaceholder.displayName}`
      )}
      flex
      alignCenter
      justifyContentCenter
    >
      {spinner ? <Spinner /> : <BrandLogo animate />}
    </FlexContainer>
  );
};

LoadingPlaceholder.displayName = 'LoadingPlaceholder';

export default LoadingPlaceholder;
